/* Stacked fade carousel for the PDP gallery: dots and arrows navigate all
   product images inside the fixed square pane. Desktop only; mobile keeps
   the native swipe slider. */
(function () {
  function init() {
    document.querySelectorAll('.product__media-wrapper').forEach(function (wrap) {
      if (wrap.dataset.gGallery) return;
      var list = wrap.querySelector('.product__media-list');
      if (!list) return;
      var items = Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
      if (!items.length) return;
      wrap.dataset.gGallery = '1';
      // Dawn hides non-featured media in thumbnail layouts; unhide so every
      // slide exists and its lazy image can load.
      items.forEach(function (it) {
        it.removeAttribute('hidden');
      });
      var idx = 0;
      var dots = [];

      function setActive(i) {
        idx = (i + items.length) % items.length;
        var img = items[idx].querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
        items.forEach(function (it, j) { it.classList.toggle('g-active', j === idx); });
        dots.forEach(function (d, j) { d.classList.toggle('g-dot--active', j === idx); });
      }

      if (items.length > 1) {
        var nav = document.createElement('div');
        nav.className = 'g-dots';
        items.forEach(function (_, j) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'g-dot';
          b.setAttribute('aria-label', 'Image ' + (j + 1) + ' of ' + items.length);
          b.addEventListener('click', function () { setActive(j); });
          nav.appendChild(b);
          dots.push(b);
        });
        wrap.appendChild(nav);

        [['prev', '‹', 'Previous image'], ['next', '›', 'Next image']].forEach(function (a) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'g-gal-arrow g-gal-arrow--' + a[0];
          b.textContent = a[1];
          b.setAttribute('aria-label', a[2]);
          b.addEventListener('click', function () { setActive(idx + (a[0] === 'prev' ? -1 : 1)); });
          wrap.appendChild(b);
        });
      }
      setActive(0);
    });
  }
  /* Wishlist and Share live under different parents (the wishlist app
     injects itself inside the product form), so join them into one row. */
  function utilityRow() {
    var container = document.querySelector('.product__info-container');
    if (!container) return;
    var row = container.querySelector('.g-utility-row');
    var wishlist = container.querySelector('.wishlisthero-product-page-button-container:not(.g-utility-row .wishlisthero-product-page-button-container)');
    var share = container.querySelector('share-button, .share-button');
    if (!row) {
      if (!wishlist && !share) return;
      row = document.createElement('div');
      row.className = 'g-utility-row';
      var anchor = wishlist ? wishlist.closest('product-form') || wishlist : share;
      anchor.parentNode.insertBefore(row, anchor.nextSibling);
    }
    // Capture (or re-capture) anything the app injected outside the row.
    container.querySelectorAll('.wishlisthero-product-page-button-container').forEach(function (wl) {
      if (!row.contains(wl)) row.insertBefore(wl, row.firstChild);
    });
    if (share && !row.contains(share)) row.appendChild(share);
    // The app sometimes leaves duplicate button containers behind: keep the
    // first, remove the rest so a stray full-text button can never show.
    var wls = row.querySelectorAll('.wishlisthero-product-page-button-container');
    for (var i = 1; i < wls.length; i++) wls[i].remove();
  }

  function boot() {
    init();
    utilityRow();
    // The wishlist app re-renders its button at unpredictable times; keep
    // folding whatever it injects back into the icon row.
    var info = document.querySelector('.product__info-container');
    if (info) new MutationObserver(utilityRow).observe(info, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', utilityRow);
})();
